import React, { useEffect, useState } from 'react';
import { ArrowUp16, ArrowsVertical16, ArrowDown16 } from '@carbon/icons-react';

import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableContainer,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Pagination
} from 'carbon-components-react';
import { Header } from 'redux/member/types';
import DisplayUserRow from './DisplayUserRow';
import { SearchedUser } from '../types';
import { Filter16 } from '@carbon/icons-react';
import EmptyStatePage from './EmptyState';

const PageSizes = [10, 20, 50];

interface Props {
  responseUsers: Array<SearchedUser> | null;
  pageInfo: any;
  setApiError: any;
  handleOpenCloseFilter: any;
  handleSetUserId: any;
  handleChangeSearchBy: any;
  sortOrder: any;
  setSortOrder: any;
}

const ShowSortOrder: React.FC<any> = ({
  colName,
  sortOrder,
  setSortOrder
}): any => {
  const handleSortOrder = () => {
    setSortOrder({
      sortedBy: colName,
      sortedOrder:
        sortOrder.sortedBy === colName
          ? sortOrder.sortedOrder === 'A'
            ? 'D'
            : 'A'
          : 'A'
    });
  };
  return (
    <div onClick={handleSortOrder}>
      {colName !== sortOrder.sortedBy ? (
        <ArrowsVertical16 />
      ) : sortOrder.sortedOrder === 'A' ? (
        <ArrowUp16 />
      ) : (
        <ArrowDown16 />
      )}
    </div>
  );
};
const DisplayUsers: React.FC<Props> = ({
  responseUsers,
  pageInfo,
  setApiError,
  handleOpenCloseFilter,
  handleSetUserId,
  handleChangeSearchBy,
  sortOrder,
  setSortOrder
}) => {
  const [users, setUsers] = useState<Array<any> | null>(null);
  useEffect(() => {
    setUsers(responseUsers);
  }, [responseUsers]);
  const headers: Array<Header> = [
    {
      key: 'email',
      header: 'Email'
    },
    { key: 'firstName', header: 'First name' },
    { key: 'lastName', header: 'Last name' },
    { key: 'roles', header: 'Role' },
    { key: 'lastLoggedInAt', header: 'Last login' }
  ];
  return (
    <>
      <DataTable rows={users || []} headers={headers}>
        {({ rows, getTableProps, getHeaderProps, getRowProps }: any) => {
          return (
            <TableContainer>
              <TableToolbar>
                <TableToolbarContent>
                  <TableToolbarSearch
                    onChange={(e: any) => {
                      handleChangeSearchBy(e.target.value);
                    }}
                  />
                  <div
                    className="search-user-filter-button"
                    onClick={handleOpenCloseFilter}
                  >
                    <Filter16 />
                  </div>
                </TableToolbarContent>
              </TableToolbar>
              <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    <TableHeader
                      key="email"
                      {...getHeaderProps({ key: 'email', header: 'Email' })}
                    >
                      <div className="search-users-sort-header">
                        <div>Email address</div>
                        <ShowSortOrder
                          colName="email"
                          sortOrder={sortOrder}
                          setSortOrder={setSortOrder}
                        />
                      </div>
                    </TableHeader>
                    <TableHeader
                      key="firstName"
                      {...getHeaderProps({
                        key: 'firstName',
                        header: 'First name'
                      })}
                    >
                      <div className="search-users-sort-header">
                        <div>First name / Last name</div>
                        <ShowSortOrder
                          colName="firstName"
                          sortOrder={sortOrder}
                          setSortOrder={setSortOrder}
                        />
                      </div>
                    </TableHeader>
                    <TableHeader
                      key="role"
                      {...getHeaderProps({ key: 'role', header: 'Role' })}
                    >
                      <div className="search-users-sort-header">
                        <div>Role</div>
                        <ShowSortOrder
                          colName="role"
                          sortOrder={sortOrder}
                          setSortOrder={setSortOrder}
                        />
                      </div>
                    </TableHeader>
                    <TableHeader
                      key="lastLoginInAt"
                      {...getHeaderProps({
                        key: 'lastLoggedInAt',
                        header: 'Last login'
                      })}
                    >
                      <div className="search-users-sort-header">
                        <div>Last login</div>
                        <ShowSortOrder
                          colName="lastLoggedInAt"
                          sortOrder={sortOrder}
                          setSortOrder={setSortOrder}
                        />
                      </div>
                    </TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row: any, index: any) => (
                    <DisplayUserRow
                      row={row}
                      getRowProps={getRowProps}
                      key={index}
                      setApiError={setApiError}
                      handleSetUserId={handleSetUserId}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          );
        }}
      </DataTable>

      {users && users?.length < 1 && <EmptyStatePage />}
      {users && users?.length >= 1 && (
        <Pagination
          onChange={pageInfo.handleFetchNextPage}
          backwardText="Previous page"
          forwardText="Next page"
          itemsPerPageText="Items per page:"
          page={pageInfo.currentPage}
          pageNumberText="Page Number"
          pageSize={pageInfo.pageSize}
          pageSizes={PageSizes}
          totalItems={pageInfo.totalItems}
        />
      )}
    </>
  );
};
DisplayUsers.displayName = 'DisplayUsers';
export default DisplayUsers;
